import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { sportTypeIds } from '../../../utils/eventConstants';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { EventCard } from '../../../components/cards';

import { getEventsNearMe } from '../../../actions/search-actions';

const EventsNearMe = (props) => {
    // component props
    const { filterPreferences, isPBRPlayer, isOnDashboard } = props;
    // redux mapping
    const { eventsNearMe = [], loading, auth } = props;
    filterPreferences.ballTypes = isPBRPlayer === true ? { Red: true, Orange: true, Green: true } : {};

    useEffect(() => {
        if (!loading) {
            props.getEventsNearMe(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        props.history.push('/search?type=events');
    };

    const showTennisContent = auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = auth?.feedPreferences?.showPickleballContent;
    const filteredEventsNearMe = eventsNearMe.filter(event => {
        if (!!showTennisContent && event?.source?.sportTypeId === sportTypeIds.TENNIS) {
            return true;
        } if (!!showPickleballContent && event?.source?.sportTypeId === sportTypeIds.PICKLEBALL) {
            return true;
        }
        return false;
    });

    return (
        <div>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'Events Near Me'} data-testid="dashboard.events-near-me.section-heading" />
                        <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.events-near-me.view-all-btn">
                            View All
                        </div>
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {filteredEventsNearMe?.length ? (
                    filteredEventsNearMe.map((event) => {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={event.source.id}
                            >
                                <EventCard
                                    event={event.source}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    isOnDashboard={isOnDashboard}
                                    data-testid={`dashboard.events-near-me.item-${event.source.id}`}
                                />
                            </div>
                        );
                    })
                ) : (
                    isPBRPlayer === true ? <div className="col" data-testid="dashboard.events-near-me.empty-message-pbr">There are no Color Ball Rating events in your area</div>
                        : <div className="col" data-testid="dashboard.events-near-me.empty-message">There are no upcoming events in your area</div>
                )}
            </div>
        </div>
    );
};

EventsNearMe.propTypes = {
    eventsNearMe: PropTypes.instanceOf(Array),
    loading: PropTypes.bool,
    auth: PropTypes.instanceOf(Object).isRequired,
};

EventsNearMe.defaultProps = {
    eventsNearMe: [],
    loading: false,
};

function mapStateToProps({ homepage, auth }) {
    const { eventsNearMe = {} } = homepage;
    const { data, loading, error } = eventsNearMe;
    return { eventsNearMe: data, loading, error, auth };
}
const mapDispatchToProps = {
    getEventsNearMe,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventsNearMe));
